import { Col, Row } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import AntInput from 'antd/lib/input';
import Table, { ColumnProps, RowSelectionType, TableRowSelection } from 'antd/lib/table';
import classNames from 'classnames';
import CollapsibleCard from 'components/CollapsibleCard/CollapsibleCard';
import { generalLanguageKeys } from 'config/consts';
import { renderMasterIndex } from 'helpers/ant-design/table';
import { AppUser } from 'models/AppUser';
import { LdapUser } from 'models/LdapUser';
import { LdapUserFilter } from 'models/LdapUserFilter';
import React, { Dispatch, RefObject, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Modal, ModalBody, ModalProps } from 'reactstrap';
import nameof from 'ts-nameof.macro';

export interface AppUserLdapIProps extends ModalProps {
    list?: LdapUser[];
    selectedList?: LdapUser[];
    setSelectedList?: Dispatch<SetStateAction<LdapUser>>;
    loading?: boolean;
    filter?: LdapUserFilter;
    handleFilter?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onSave?: (model: AppUser) => void;
    onClose?: () => void;
}

export function AppUserLdapMappingModal(
    props: AppUserLdapIProps,
) {
    const [translate] = useTranslation();
    const {
        list,
        loading,
        filter,
        handleFilter,
        onClose,
        onSave,
        isOpen,
        toggle,
        selectedList,
        setSelectedList,
    } = props;

    const ref: RefObject<AntInput> = React.useRef<AntInput>(null);

    const rowSelectionType: RowSelectionType = 'radio';

    const rowSelection: TableRowSelection<LdapUser> = {

        type: rowSelectionType,
        selectedRowKeys: selectedList?.map((t: LdapUser) => t?.key),
        onSelect: (record: LdapUser, selected: boolean) => {
            if (selected) {
                const selectedItem = [record];
                setSelectedList(selectedItem);
            }
        },
    };


    const columns: ColumnProps<LdapUser>[] = React.useMemo(() => {
        return [
            {
                key: generalLanguageKeys.columns.index,
                title: translate(generalLanguageKeys.columns.index),
                width: 60,
                render: renderMasterIndex<LdapUser>(),
            },
            {
                key: nameof(list[0].ldapUsername),
                dataIndex: nameof(list[0].ldapUsername),
                title: translate('appUsers.username'),

            },
            {
                key: nameof(list[0].displayName),
                dataIndex: nameof(list[0].displayName),
                title: translate('appUsers.displayName'),

            },
        ];
    }, [list, translate]);
    return (
        <Modal
            size="xl"
            unmountOnClose={true}
            backdrop="static"
            toggle={toggle}
            isOpen={isOpen}
        >
            <ModalBody>
                <CollapsibleCard
                    className="head-borderless mb-3"
                    title={translate(generalLanguageKeys.actions.search)}
                >
                    <Form>
                        <Row>

                            <Col className="pl-1" span={8}>
                                <FormItem
                                    className="mb-0"
                                    label={translate('appUsers.username')}
                                    labelAlign="left"
                                >
                                    <AntInput
                                        type="text"
                                        ref={ref}
                                        className={classNames('advanced-string-filter')}
                                        placeholder={'Nhập tên đăng nhập cần tìm kiếm'}
                                        defaultValue={filter.ldapUsername}
                                        size="small"
                                        onChange={handleFilter}
                                    />
                                </FormItem>
                            </Col>

                        </Row>

                    </Form>
                </CollapsibleCard>
                <Table
                    columns={columns}
                    dataSource={list}
                    loading={loading}
                    scroll={{ y: 500 }}
                    rowSelection={rowSelection}
                    rowKey={nameof(list[0].key)}
                    pagination={false}
                    className="ml-3"
                    tableLayout="fixed"

                />
                <div className=" d-flex justify-content-end mt-3">
                    <button
                        className="btn btn-sm btn-primary"
                        onClick={() => onSave(selectedList)}
                    >
                        <i className="fa mr-2 fa-save" />
                        {translate(generalLanguageKeys.actions.save)}
                    </button>
                    <button
                        className="btn btn-sm btn-outline-primary ml-2"
                        onClick={onClose}
                    >
                        <i className="fa mr-2 fa-times-circle" />
                        {translate(generalLanguageKeys.actions.cancel)}
                    </button>
                </div>
            </ModalBody>
        </Modal>
    );
}
